import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';

import { FrontendLoggerService } from '../../errors/error-handling/frontend-logger.service';

/**
 * Service for sending keep alive requests.
 *
 * @author Jesse Bloomster e020902
 */
@Injectable({
	providedIn: 'root'
})
export class KeepAliveService {
	private keepAliveUrl = '/gateway/keepAlive';

	/**
	 * @param http the Angular Http Client
	 * @param frontendLoggerService the frontend logger service
	 */
	constructor(
		private http: HttpClient,
		private frontendLoggerService: FrontendLoggerService
	) {}

	/**
	 * Send a keep alive request to the server. If the request is successful, the session has been refreshed. An
	 * error indicates the session is no longer valid.
	 */
	keepAlive = (): Observable<boolean> =>
		this.http.get(this.keepAliveUrl).pipe(
			map(() => true),
			catchError((error: unknown) => {
				this.frontendLoggerService.warn(`KeepAlive request failed with: ${error}`);
				return of(false);
			})
		);
}
